document.addEventListener("DOMContentLoaded", function () {

    // -----------------------------------------------------
    // Get Elements
    // -----------------------------------------------------

    const modal = document.getElementById("customizerModal");
    const form = document.getElementById("customizerForm");
    const closeBtn = document.getElementById("closeCustomizer");

    const popupTitle = document.getElementById("popupProductTitle");
    const productField = document.getElementById("popupProduct");
    const productURLField = document.getElementById("popupProductURL");

    const customerMessage = document.getElementById("customerMessage");
    const charCount = document.getElementById("charCount");

    const successMessage = document.getElementById("customizerSuccess");

    // -----------------------------------------------------
    // Show success message after page reload
    // -----------------------------------------------------
if (sessionStorage.getItem("customizerSuccess") === "true") {

    sessionStorage.removeItem("customizerSuccess");

    if (successMessage) {

        successMessage.style.display = "block";

        successMessage.scrollIntoView({
            behavior: "smooth",
            block: "center"
        });

        // Auto hide after 5 seconds

       setTimeout(function(){

    successMessage.classList.add("fade-out");

    setTimeout(function(){

        successMessage.style.display = "none";
        successMessage.classList.remove("fade-out");

    },500);

},5000);

    }

}

const closeSuccess =
    document.getElementById("closeCustomizerSuccess");

if (closeSuccess && successMessage) {

    closeSuccess.addEventListener("click", function(){

        successMessage.style.display = "none";

    });

}

    // -----------------------------------------------------
    // Open Popup
    // -----------------------------------------------------

    document.querySelectorAll(".open-customizer").forEach(function (button) {

        button.addEventListener("click", function () {

            // Reset only the fields that should be cleared

            const customerName = document.getElementById("customerName");
            const customerEmail = document.getElementById("customerEmail");
            const customerMobile = document.getElementById("customerMobile");

            if (customerName)
                customerName.value = customerName.defaultValue;

            if (customerEmail)
                customerEmail.value = customerEmail.defaultValue;

            if (customerMobile)
                customerMobile.value = "";

            if (customerMessage)
                customerMessage.value = "";

            if (charCount)
                charCount.textContent = "0";

            if (charCount) {
                charCount.textContent = "0";
            }

            const popupSuccess = document.querySelector(".customizer-success");

            if (popupSuccess) {

                 popupSuccess.remove();

            }

            if (popupTitle) {
                popupTitle.innerHTML =
                    "<strong>Product:</strong> " + this.dataset.productTitle;
            }

            if (productField) {
                productField.value = this.dataset.productTitle;
            }

            if (productURLField) {
                productURLField.value = this.dataset.productUrl;
            }

            if (modal) {
                modal.classList.add("active");
            }

            if (customerMessage) {
                customerMessage.focus();
            }

        });

    });

    // -----------------------------------------------------
    // Close Popup
    // -----------------------------------------------------

    if (closeBtn) {

        closeBtn.addEventListener("click", function () {

            if (modal) {
                modal.classList.remove("active");
            }

        });

    }

    // -----------------------------------------------------
    // Click Outside Popup
    // -----------------------------------------------------

    window.addEventListener("click", function (event) {

        if (event.target === modal) {

            modal.classList.remove("active");

        }

    });

    // -----------------------------------------------------
    // Character Counter
    // -----------------------------------------------------

    if (customerMessage && charCount) {

        customerMessage.addEventListener("input", function () {

            charCount.textContent = this.value.length;

        });

    }

    // -----------------------------------------------------
    // Form Submission
    // -----------------------------------------------------

    if (form) {

        form.addEventListener("submit", function () {

            sessionStorage.setItem("customizerSuccess", "true");

            if (!customerMessage) return;

            const originalMessage = customerMessage.value;

            customerMessage.value =
`PRODUCT CUSTOMIZATION REQUEST

========================================

Product:
${productField ? productField.value : ""}

Product URL:
${productURLField ? productURLField.value : ""}

Customer Name:
${document.getElementById("customerName")?.value || ""}

Email:
${document.getElementById("customerEmail")?.value || ""}

Mobile:
${document.getElementById("customerMobile")?.value || ""}

========================================

CUSTOMIZATION REQUEST

${originalMessage}`;

        });

    }

});